<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton icon="fa-plus" v-on:click="onClickButton" />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <InstallInstructionsList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import InstallInstructionsList from "@/components/settings/integrador/install-instructions/InstallInstructionsList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "IntegratorInstallInstructionsListView",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    InstallInstructionsList,
  },
  methods: {
    onClickButton(e) {
      this.$router.push({ name: "addintegratorinstallinstructions" });
    },
  },
};
</script>
